import { format } from 'date-fns';

const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]+$/;
// Regex with (_ and -)
const ALPHANUMERIC_WITH_SYMBOLS_REGEX = /^[a-zA-Z0-9_-]+$/;

export function hasOnlyOneValueForThisKey(array, keyToCheck) {
  const val = [];

  for (const obj of array) {
    if (Object.prototype.hasOwnProperty.call(obj, keyToCheck)) {
      val.push(obj[keyToCheck]);
      if (val.length > 1) {
        return false;
      }
    }
  }

  return true;
}

export function capitalizeFirstLetter(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : string;
}

export function toTitleCase(string) {
  return string.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}

export function convertToUserTimezone(
  dateString,
  userTimezone,
  targetFormat = 'yyyy-MM-dd HH:mm:ss'
) {
  if (dateString) {
    // Convert the date string to a Date object
    const date = new Date(
      dateString.includes('Z') ? dateString : `${dateString}Z`
    );

    const formattedDate = format(date, targetFormat);

    return formattedDate;
  }
  return null;
}

export function getUserTimezone() {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return userTimezone;
}

export function maskPhoneNumber(phone, hiddenNumbers = 8) {
  return `${'X'.repeat(hiddenNumbers)}${phone.slice(hiddenNumbers)}`;
}

export function getWeekOfMonth(date) {
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const dayOfWeek = firstDayOfMonth.getDay();
  const adjustedDate = date.getDate() + dayOfWeek;
  return Math.ceil(adjustedDate / 7);
}


export function formatLanguageDate(date, locale = "en") {
  try {
    return new Intl.DateTimeFormat(locale, {
      day: "2-digit",
      month: "long",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(new Date(date));
  } catch (error) {
    return date;
  }
}

export function compareObjects(A, B) {
  if (Object.keys(A || {}).length !== Object.keys(B || {}).length) {
    return false;
  }
  for (const key in A) {
    if (typeof A[key] === "object" && typeof B[key] === "object") {
      if (!compareObjects(A[key], B[key])) {
        return false;
      }
    } else if (A[key] !== B[key]) {
      return false;
    }
  }
  return true;
}

export function isPlainObject(value) {
  /**
 * Retrieves the prototype of the specified value.
 *
 * @param {*} value The value to get the prototype from.
 * @returns {object | null} The prototype of the value, or null if the value is null or undefined.
 */

  // 1. Initial checks: Must be an object and not null
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  // 2. Check objects created with Object.create(null)
  // Their prototype is null, which is a valid form of plain object.

  const prototype = Object.getPrototypeOf(value);
  if (prototype === null) {
    return true;
  }

  // 3. Check objects whose prototype chain ends in Object.prototype
  // This handles {} and new Object() in the same realm.
  // For cross-realm objects, we need a more dynamic check.
  if (prototype === Object.prototype) {
    // Exclude objects with specific Symbol properties that indicate they are not plain
    // (e.g., Atomics, JSON, or custom iterables that are not simple data containers)
    return !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
  }

  // 4. For objects from other realms or with complex prototype chains,
  // traverse the chain to ensure it eventually leads to Object.prototype of its realm.
  let currentProto = value;
  while (Object.getPrototypeOf(currentProto) !== null) {
    currentProto = Object.getPrototypeOf(currentProto);
  }
  // The final prototype in its chain must be Object.prototype (of its realm).
  // Also, make sure it doesn't have special Symbol properties.
  return currentProto === Object.prototype && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

export function isValidJson(string) {
  if (!string || string === null) return false;

  try {
    JSON.parse(string);
    return true;
  } catch (error) {
    return false;
  }
}

// Validates if a string is alphanumeric, with an option to allow symbols.
export const validateAlphanumeric = (value, { allowSymbols = false } = {}) => {
  if (!value) return true;

  const regex = allowSymbols
    ? ALPHANUMERIC_WITH_SYMBOLS_REGEX
    : ALPHANUMERIC_REGEX;

  return regex.test(value);
};